define([
	"dojo/_base/declare",
	"csi/access/crews",
	"csi/action/NewFrom",
	"csi/def",
	"csi/xml",
	"Apparel/ProductType"
], function(declare,crews,NewFrom,def,xml,ProductType) {

	return declare(NewFrom, {
		validate: function(/*Context*/ctx) {
			// summary: don't show action is user does not have proper access
			var	style = ctx.getNode();
			return style &&
				xml.nodeHasRight(style, xml.RIGHT_WRITE) &&
				def.canNavigateToType("Theme") &&
				crews.isInGlobalRoles(["Theme Administrator","Theme Editor"]) &&
				ProductType.hasColor(style) &&
				this.inherited(arguments);
		}
	});
});